import type { Feature } from '@luna/gatekeeper';

export const georgeIdMigrationTour: Feature = {
    enabled: true,
    _description: 'Shows a tour for switching from legacy signing application to George ID',
};
